import Vue from 'vue';

function applyAnimation(el, binding, vnode) {
  const seconds = binding.value || 0.5;
  el.classList.add('animated');
  el.classList.add('fadeInDown');
  el.style.animationDelay = `${seconds}s`;
}

Vue.directive('animate-fade', {
  inserted: applyAnimation,
});

export {
  applyAnimation
}
